@if (showModal()) {
<div class="cookie-consent-overlay">
  <div class="cookie-consent-modal" [class.rtl]="isRtl()">
    <div class="cookie-content">
      <h2 class="cookie-title">{{ 'COOKIE_TITLE' | translate }}</h2>
      <p class="cookie-description">{{ 'COOKIE_DESCRIPTION' | translate }}</p>

      @if (showDetails()) {
      <div class="cookie-options">
        <div class="cookie-option">
          <div class="option-header">
            <label for="necessary" class="toggle-switch" [class.disabled]="true">
              <span class="text">{{'COOKIE_NECESSARY'|translate}}</span>
              <input type="checkbox" id="necessary" [checked]="preferences().necessary" disabled>
              <span class="slider"></span>
            </label>
          </div>
          <p class="option-description">{{ 'COOKIE_NECESSARY_DESC' | translate }}</p>
        </div>

        <div class="cookie-option">
          <div class="option-header">
            <label for="preferential" class="toggle-switch">
              <span class="text">{{'COOKIE_PREFERENTIAL'|translate}}</span>
              <input type="checkbox" id="preferential" [checked]="preferences().preferential"
                (change)="togglePreference('preferential')">
              <span class="slider"></span>
            </label>
          </div>
          <p class="option-description">{{ 'COOKIE_PREFERENTIAL_DESC' | translate }}</p>
        </div>

        <div class="cookie-option">
          <div class="option-header">
            <label for="statistical" class="toggle-switch">
              <span class="text">{{'COOKIE_STATISTICAL'|translate}}</span>
              <input type="checkbox" id="statistical" [checked]="preferences().statistical"
                (change)="togglePreference('statistical')">
              <span class="slider"></span>
            </label>
          </div>
          <p class="option-description">{{ 'COOKIE_STATISTICAL_DESC' | translate }}</p>
        </div>

        <div class="cookie-option">
          <div class="option-header">
            <label for="marketing" class="toggle-switch">
              <span class="text">{{'COOKIE_MARKETING'|translate}}</span>
              <input type="checkbox" id="marketing" [checked]="preferences().marketing"
                (change)="togglePreference('marketing')">
              <span class="slider"></span>
            </label>
          </div>
          <p class="option-description">{{ 'COOKIE_MARKETING_DESC' | translate }}</p>
        </div>
      </div>
      }

      <button class="view-details-btn" name="btn-view-details" (click)="toggleDetails()" type="button">
        {{ (showDetails() ? 'COOKIE_HIDE_DETAILS' : 'COOKIE_VIEW_DETAILS') | translate }}
        <span class="arrow" [class.open]="showDetails()">›</span>
      </button>
    </div>

    <div class="cookie-actions">
      <button name="btn-enable-all" class="btn-primary" (click)="enableAll()" type="button">
        {{ 'COOKIE_ENABLE_ALL' | translate }}
      </button>
      <button name="btn-enable-selection" class="btn-secondary" (click)="enableSelection()" type="button">
        {{ 'COOKIE_ENABLE_SELECTION' | translate }}
      </button>
      <button name="btn-reject" class="btn-tertiary" (click)="reject()" type="button">
        {{ 'COOKIE_REJECT' | translate }}
      </button>
    </div>
  </div>
</div>
}